// extracted by mini-css-extract-plugin
export default {"root":"DebugPanel_root__4iMhd","info":"DebugPanel_info__Y3D+1"};